module.exports = "<div class=\"animate-show\" *ngIf=\"show\">\n\t<ng-content></ng-content>\n</div>"